import { lazy, Suspense } from "react";
import { DataRouteObject, Navigate } from "react-router-dom";
import { AuthGuard } from "src/components/guards/auth-guard";
import { LoadingScreen } from "src/components/loading-screen";
import { Layout } from "src/layout/main-layout";

const Loadable = Component => props =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

const Reservations = Loadable(
  lazy(() =>
    import("src/features/security-parking-bookings/containers").then(module => ({
      default: module.ReservationsContainer,
    })),
  ),
);

const Reservation = Loadable(
  lazy(() =>
    import("src/features/security-parking-bookings/containers/[reservationId]").then(module => ({
      default: module.ReservationContainer,
    })),
  ),
);
//temporary disabled
// const Resources = Loadable(
//   lazy(() =>
//     import("src/features/security-parking-spots/containers/spots").then(module => ({
//       default: module.SpotsContainer,
//     })),
//   ),
// );

const ChangePassword = Loadable(
  lazy(() =>
    import("src/features/security-settings/containers/change-password").then(module => ({
      default: module.ChangePasswordContainer,
    })),
  ),
);

const Contact = Loadable(
  lazy(() =>
    import("src/features/security-settings/containers/contact").then(module => ({
      default: module.ContactContainer,
    })),
  ),
);

const routes: DataRouteObject[] = [
  {
    path: "/",
    id: "/reservations-container",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      {
        id: "/reservations",
        path: "/",
        element: <Navigate to="/reservations" replace />,
      },
    ],
  },
  {
    id: "reservations-container",
    path: "reservations",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      {
        id: "reservations",
        path: "/reservations",
        element: <Reservations />,
      },
      {
        id: "reservation",
        path: "/reservations/:reservationId",
        element: <Reservation />,
      },
    ],
  },

  //temporary disabled

  // {
  //   id: "resource-container",
  //   path: "resource",
  //   element: (
  //     <AuthGuard>
  //       <Layout />
  //     </AuthGuard>
  //   ),
  //   children: [
  //     {
  //       id: "resource-index",
  //       index: true,
  //       element: <Navigate to="/resource/spots" replace />,
  //     },
  //     {
  //       id: "resource-spots",
  //       path: "/resource/spots",
  //       element: <Resources />,
  //     },
  //   ],
  // },
  {
    id: "settings-container",
    path: "settings",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      {
        id: "settings-index",
        index: true,
        element: <Navigate to="/settings/change-password" replace />,
      },
      {
        id: "settings-change-password-form",
        path: "/settings/change-password",
        element: <ChangePassword />,
      },
      {
        id: "settings-contact-form",
        path: "/settings/contact-form",
        element: <Contact />,
      },
    ],
  },
];

export default routes;
